module.exports = __webpack_public_path__ + "img/no-image-available.e46fba01.gif";